enum ErrorType {
  Component = 0,
  Network = 1,
  File = 2
}

export default ErrorType
